import React from 'react'
import { isEmpty } from 'lodash';
import {
  Badge
} from '@superops/ui-design-system';

function StatusBadge({ statusValue }) {

  const getStatusColor = (status) => {
    switch (status) {
      case 'ONLINE':
        return 'success';
      case 'UNKNOWN':
        return 'warning';
      default:
        return '';
    }
  }

  return (
    <Badge
      size="large"
      status={getStatusColor(statusValue)}
    >
      {statusValue}
    </Badge>
  )
}

export default StatusBadge